import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="error_circle" size=32 />
 */

var PlayCircleBtn = function PlayCircleBtn() {
  return React.createElement("svg", {
    style: {
      color: 'white',
      fontWeight: 'bold'
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    fill: "currentColor",
    className: "bi bi-play-circle",
    viewBox: "0 0 16 16"
  }, ' ', React.createElement("path", {
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z",
    fill: "white"
  }), ' ', React.createElement("path", {
    d: "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z",
    fill: "white"
  }), ' ');
};

export default PlayCircleBtn;